import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { I18NextPipe } from 'angular-i18next';
import {
  CardGroupComponent,
  ClipboardComponent,
  FormGroupComponent,
  InputComponent,
  InputLabelComponent,
  InputPasswordComponent,
  SelectComponent
} from 'mbs-ui-kit';
import { StorageType } from 'mbs-ui-shared';
import { e2eLocators, fakeSecretKey } from '../credential-forms.constants';
import { AccountType, AzureCredentialForm } from '../credential-forms.model';
import { getAccountTypes, ServiceEnpoint, ServiceEnpointHints } from './credential-form-azure.constants';

@UntilDestroy()
@Component({
  selector: 'mbs-credential-form-azure',
  templateUrl: './credential-form-azure.component.html',
  styleUrls: ['../credential-forms.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CardGroupComponent,
    ClipboardComponent,
    FormGroupComponent,
    InputComponent,
    InputLabelComponent,
    InputPasswordComponent,
    ReactiveFormsModule,
    SelectComponent,
    I18NextPipe
  ]
})
export class CredentialFormAzureComponent implements OnInit {
  private i18n = inject(I18NextPipe);

  @Input() form: AzureCredentialForm;

  public readonly StorageType = StorageType;
  public readonly AccountType = AccountType;
  public readonly fakeSecretKey = fakeSecretKey;
  public readonly ServiceEndpointHints = ServiceEnpointHints;
  public readonly accountTypes = getAccountTypes(this.i18n);
  public readonly e2eLocators = e2eLocators;

  ngOnInit() {
    this.accountTypeControl.valueChanges.pipe(untilDestroyed(this)).subscribe((val) => {
      this.endpointControl.patchValue(ServiceEnpoint?.[val] || '');
    });

    this.accountNameControl.valueChanges.pipe(untilDestroyed(this)).subscribe(() => {
      this.sharedKeyControl.patchValue('');
      this.sharedKeyControl.updateValueAndValidity();
    });
  }

  public get accountType(): AccountType {
    return this.accountTypeControl.value;
  }

  public get accountTypeControl(): FormControl {
    return this.form.get('accountType') as FormControl;
  }

  public get sharedKeyControl(): FormControl {
    return this.form.get('sharedKey') as FormControl;
  }

  public get accountNameControl(): FormControl {
    return this.form.get('accountName') as FormControl;
  }

  public get endpointControl(): FormControl {
    return this.form.get('endpoint') as FormControl;
  }
}
